import { MinusIcon } from '@pmi/dsm-react/dist/components/icons/16';

export default function CustomMinusIcon() {
  return (
    <span className="mui-checkbox-component__icon mui-checkbox-component__icon--checked">
      <MinusIcon fontSize="xs" />
    </span>
  );
}
